export const DOC_UPLOAD_FETCH_REQUEST = 'DOC_UPLOAD_FETCH_REQUEST';
export const DOC_UPLOAD_FETCH_SUCCESS = 'DOC_UPLOAD_FETCH_SUCCESS';
export const DOC_UPLOAD_FETCH_FAILURE = 'DOC_UPLOAD_FETCH_FAILURE';
